export default "__VITE_ASSET__16458108__"